import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';

import DropdownComponent from './DropdownComponent';

const DropdownContainer = ({
  onSelect: onSelectCallback,
  selectedValue: controlledSelectedValue,
  options,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = React.useState(controlledSelectedValue || '');
  const [isOpen, setOpen] = useState(false);
  const containerRef = useRef();

  const toggleOpen = () => {
    const newState = !isOpen;

    setOpen(newState);
  };

  const onSelect = (option) => {
    setSelectedValue(option.value);
    onSelectCallback(option.value);
    toggleOpen();
  };

  const outsideClick = useCallback((event) => {
    if (event?.target && containerRef.current && !containerRef.current.contains(event.target)) {
      setOpen(false);
    }

    return null;
  }, []);

  useEffect(() => {
    window.addEventListener('click', outsideClick, false);

    return () => {
      window.removeEventListener('click', outsideClick);
    };
  }, [outsideClick]);

  useEffect(() => {
    setSelectedValue(controlledSelectedValue || '');
  }, [controlledSelectedValue]);

  return (
    <DropdownComponent
      {...{
        ...props,
        onSelect,
        containerRef,
        toggleOpen,
        options,
        selectedOption: options.find(
          (option) => option.value.toString() === selectedValue.toString()
        ),
        isOpen,
        hasSelectedValue: !!selectedValue,
      }}
    />
  );
};

DropdownContainer.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number]),
  })).isRequired,
  onSelect: PropTypes.func,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DropdownContainer;
